// @flow

import Routes from './';

function ActiveRoute() {
    const routePath = `${window.location.href.toLowerCase()}/`;
    var currentRoute = '';
    switch (true) {
    case routePath.indexOf(`/${Routes.ApiProducts}/`) >= 0:
        currentRoute = Routes.ApiProducts;
        break;
    case routePath.indexOf(`/${Routes.Docs}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.GetDocs}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DownloadDocs}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DocsBinder}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DocsServiceType}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DocsOfficeLocation}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DocsSate}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.DocsPage}/`) >= 0:
        currentRoute = Routes.Docs;
        break;
    case routePath.indexOf(`/${Routes.Api}/`) >= 0:
        currentRoute = Routes.Api;
        break;
    case routePath.indexOf(`/${Routes.ChangeLog}/`) >= 0:
        currentRoute = Routes.ChangeLog;
        break;
    case routePath.indexOf(`/${Routes.Support}/`) >= 0:
        currentRoute = Routes.Support;
        break;
    case routePath.indexOf(`/${Routes.ContactSupport}/`) >= 0:
        currentRoute = Routes.Support;
        break;
    case routePath.indexOf(`/${Routes.SignIn}/`) >= 0:
        currentRoute = Routes.SignIn;
        break;
    case routePath.indexOf(`/${Routes.ApiDocs}/`) >= 0:
        currentRoute = Routes.ApiProducts;
        break;
    case routePath.indexOf(`/${Routes.Download}/`) >= 0:
        currentRoute = Routes.Download;
        break;

    default:
        currentRoute = Routes.Home;
        break;
    }
    return currentRoute;
}

export default ActiveRoute;
